export interface DataTypeDefaults {
    [type: string]: {
        length?: number;
        width?: number;
        precision?: number;
        scale?: number;
    };
}